import Input from './Input.js';
import ReduxFormInputAdapter from './ReduxFormInputAdapter.js';

Input.ReduxForm = ReduxFormInputAdapter;

export default Input;
export { ReduxFormInputAdapter as ReduxForm };
